import React from "react";
import { NavLink } from 'react-router-dom';

const Footer = () =>{
    return(
            <footer id="footer" className="footer">
                <div className="container">
                    <div className="row gy-3">
                        <div className="col-lg-3 col-md-6 d-flex">
                            <i className="bi bi-geo-alt icon" />
                            <div>
                            <h4>casovi.me</h4>
                                <p> <strong>
                                <NavLink to="/">Početna</NavLink></strong>
                                <br/>
                                <strong>
                                <NavLink to="/predmeti">Predmeti</NavLink>
                                </strong>
                                <br/>
                                <strong>
                                <NavLink to="uslovi-koriscenja">Uslovi korišćenja</NavLink>
                                </strong>
                                <br/>
                                 <strong>
                                <NavLink to="politika-privatnosti">Politika privatnosti</NavLink>
                                </strong>
                                <br/>
                                81000 Podgorica - Crna Gora
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 footer-links d-flex">
                            <i className="bi bi-telephone icon" />
                            <div>
                                <h4>Kontakt</h4>
                                <p>
                                    {/* <strong>Telefon:</strong> +382 67 021 120<br /> */}
                                    <strong>Email:</strong> info@casovi.me<br /></p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 footer-links d-flex">
                            <i className="bi bi-clock icon" />
                            <div>
                            <h4>Zakažite već sada</h4>
                            <p><strong>Pon-Ned:</strong> 08 - 21</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>Zapratite nas</h4>
                            <div className="social-links d-flex">
                                <a href="#proba" className="facebook"><i className="bi bi-facebook" /></a>
                                <a href="https://www.instagram.com/casovi.me/" target="_blank" rel="noreferrer" className="instagram"><i className="bi bi-instagram" /></a>
                                {/* <a href="#proba" className="twitter"><i className="bi bi-twitter" /></a>
                                <a href="#proba" className="linkedin"><i className="bi bi-linkedin" /></a> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="copyright">© Copyright<strong><span> casovi.me</span></strong>. Sva prava zadržana</div>
                </div>
            </footer>
    );
};

export default Footer;